module.exports = "/virtual-football-league/img/amblems/right/logos/Everton.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/logos/Everton.png
// module id = 2172
// module chunks = 4